var map = {
	"./2018-central-estimates-columns.png": 261,
	"./ResponsibilityGuidanceContentProps": 28,
	"./ResponsibilityGuidanceContentProps.ts": 28,
	"./ResponsibilityGuidanceModelInputsContent2017": 75,
	"./ResponsibilityGuidanceModelInputsContent2017.tsx": 75,
	"./ResponsibilityGuidanceModelInputsContent2021": 77,
	"./ResponsibilityGuidanceModelInputsContent2021.tsx": 77,
	"./ResponsibilityGuidanceModelInputsContentLatest": 78,
	"./ResponsibilityGuidanceModelInputsContentLatest.tsx": 78,
	"./ResponsibilityGuidanceModelOutputsContent2017": 79,
	"./ResponsibilityGuidanceModelOutputsContent2017.tsx": 79,
	"./ResponsibilityGuidanceModelOutputsContent2021": 81,
	"./ResponsibilityGuidanceModelOutputsContent2021.tsx": 81,
	"./ResponsibilityGuidanceModelOutputsContentLatest": 82,
	"./ResponsibilityGuidanceModelOutputsContentLatest.tsx": 82,
	"./ResponsibilityGuidanceTouchstoneNotOpenContent": 53,
	"./ResponsibilityGuidanceTouchstoneNotOpenContent.tsx": 53,
	"./guidance-201710-DALYs.pdf": 80,
	"./guidance-2019-inputs.pdf": 240,
	"./guidance-2019-outputs.pdf": 239,
	"./guidance-2021-inputs.pdf": 242,
	"./guidance-2021-outputs.pdf": 241,
	"./guidance-2023-inputs.pdf": 244,
	"./guidance-2023-outputs.pdf": 243
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;